export enum OwnerStatus {
  ACTIVE = 'ATIVO',
  INACTIVE = 'INATIVO',
  DELETED = 'REMOVIDO'
}
